module.exports = __webpack_public_path__ + "e5737136aa5846d2f0f939aa6c8191c0.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/winking-20.png
// module id = 2286
// module chunks = 0